import API from "../api";

export const sendExceptionReport = error => {
  const resourcePath = "/error-alert";
  return API.agent().post(resourcePath, error);
};
